import base from './base';

export default {
  get() {
    return base.get('cart');
  },

  update({ type, shipping_id, payment_id }) {
    return base.postFormData('cart', { type, shipping_id, payment_id });
  },

  add(product_id, quantity, type) {
    return base.postFormData(`cart/add`, { product_id, quantity, type });
  },

  edit(product_id, quantity, type) {
    return base.postFormData(`cart/edit`, { product_id, quantity, type });
  },

  remove(product_id, type) {
    return base.postFormData(`cart/remove`, { product_id, type });
  },
}
